import React from "react";
import TextInput from "../common/TextInput";
import * as StringUtil from "../utils/StringUtil";

/**
 * 여러 입력란이 있는 다이얼로그 (버튼 1개)
 * @param {*} title 다이얼로그 제목
 * @param {*} content 다이얼로그 내용
 * @param {*} input_list input 정보 리스트 (ex. [{ title: "제목1", value: "값1" }, { title: "제목2", value: "값2" }])
 * @param {*} button_text 버튼 텍스트
 * @param {*} infoText input 아래 설명문
 * @param {*} success success 표시(초록 테두리 및 체크표시)
 * @param {*} error error 표시(빨간 테두리 및 느낌표)
 * @function onButtonClick 버튼 클릭 이벤트
 * @function popup_close 팝업 닫기
 */
class InputDialogV3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            input_values: props.input_list.map((input) => input.value || ""), // input_list로 초기화
        };
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.input_list) !== JSON.stringify(prevProps.input_list)) {
            this.setState({
                input_values: this.props.input_list.map((input) => input.value || ""),
            });
        }
    }

    onChangeInputValue(index, value) {
        const updatedValues = [...this.state.input_values];
        updatedValues[index] = value;
        this.setState({ input_values: updatedValues }, () => {
            if (this.props.onChange) {
                this.props.onChange(updatedValues);
            }
        });
    }

    render() {
        const { title, content, input_list, button_text, button_color, infoText, success, error, onButtonClick, is_show_close, onPopupClose } = this.props;

        return (
            <div className="common_dialog input_dialog_v3">
                <div className="dialog_select_CTA dialog_complete">
                    {
                    is_show_close == true
                    && <div style={{position: "relative", width: "100%", height: "5px"}}>
                        <button
                        style={{
                            position: "absolute",
                            top: "-14px",
                            right: "0px",
                            border: "none",
                            background: "none",
                            cursor: "pointer",
                            width: "20px",
                            height: "20px",
                            left: "auto",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        onClick={() => onPopupClose && onPopupClose()}
                        >
                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0704 15.1788C16.1878 15.2973 16.2536 15.4573 16.2536 15.6241C16.2536 15.7909 16.1878 15.9509 16.0704 16.0694C15.9509 16.1849 15.7913 16.2495 15.6251 16.2495C15.4589 16.2495 15.2992 16.1849 15.1798 16.0694L10.0001 10.8819L4.82041 16.0694C4.70095 16.1849 4.54127 16.2495 4.3751 16.2495C4.20892 16.2495 4.04925 16.1849 3.92979 16.0694C3.81242 15.9509 3.74658 15.7909 3.74658 15.6241C3.74658 15.4573 3.81242 15.2973 3.92979 15.1788L9.11728 9.99912L3.92979 4.81943C3.83012 4.698 3.77919 4.54383 3.78689 4.38693C3.7946 4.23002 3.8604 4.08159 3.97148 3.9705C4.08256 3.85942 4.231 3.79362 4.3879 3.78592C4.54481 3.77821 4.69898 3.82914 4.82041 3.92881L10.0001 9.11631L15.1798 3.92881C15.3012 3.82914 15.4554 3.77821 15.6123 3.78592C15.7692 3.79362 15.9176 3.85942 16.0287 3.9705C16.1398 4.08159 16.2056 4.23002 16.2133 4.38693C16.221 4.54383 16.1701 4.698 16.0704 4.81943L10.8829 9.99912L16.0704 15.1788Z" fill="#333333"></path></svg>
                        </button>
                    </div>
                    }
                    <div className="dialog_select_CTA_txt">
                        <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
                        <h3 dangerouslySetInnerHTML={{ __html: content }}></h3>
                    </div>
                    <div className="input_list_wrapper">
                        {input_list.map((input, index) => (
                            <div key={index} className="input_wrapper">
                                <b className="input_title text_14">{input.title}</b>
                                <TextInput
                                    value={this.state.input_values[index]}
                                    type={input.type ? input.type : "text"}
                                    onChange={(e) => this.onChangeInputValue(index, e.target.value)}
                                    placeholder={input.placeholder || ""}
                                    infoText={infoText}
                                    success={success}
                                    error={error}
                                    width={"100%"}
                                    height={"40px"}
                                    fontSize={"14px"}
                                    autoFocus={index === 0}
                                />
                            </div>
                        ))}
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: this.props.html }}/>
                    <button
                        id="common_alert_dialog_btn"
                        onClick={() => onButtonClick(this.state.input_values)}
                    >
                        {button_text}
                    </button>
                </div>
            </div>
        );
    }
}

export default InputDialogV3;

InputDialogV3.defaultProps = {
    title: "",
    content: "",
    input_list: [], // [{ title: "Input 1", value: "Value 1" }, ...]
    button_text: "확인",
    popup_close: () => {},
    onChange: () => {},
    onButtonClick: () => {},
};